export default __webpack_public_path__ + "static/media/slider_1.467dd7fa.webp";